import { useEffect } from "react"
import { Spinner } from "@nextui-org/react";
import { useSearchParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import { logEvent } from "firebase/analytics";

import { t } from "cvpop-localization-sdk"
import { urls } from "cvpop-constants-sdk"

import { analytics } from '../../controllers/firebase';

const WebAppDownload = () => {

    // ------------------------------------------------------------------------------------------------------------------------
    const [searchParams] = useSearchParams();

    const refer = searchParams.get("refer");
    const isAppleDevice = /iPad|iPhone|iPod|Macintosh|Mac OS X|Vision Pro/.test(navigator.userAgent);
    const isAndroidDevice = /Android/.test(navigator.userAgent);
    const isMobileDevice = /Mobile|Tablet/.test(navigator.userAgent);

    const { appstore, googleplay } = urls.store

    // ------------------------------------------------------------------------------------------------------------------------
    useEffect(() => {

        if (refer) logEvent(analytics, `app_download_refer`, { partner_refer: refer });

        if (isAppleDevice) return window.location.href = appstore
        if (isAndroidDevice || isMobileDevice) return window.location.href = googleplay
        window.location.href = "/app/web";
    }, []);

    // ------------------------------------------------------------------------------------------------------------------------
    return (
        <>
            <Helmet>
                <title>{t("shareAppMsg")}</title>
            </Helmet>
            <div className="flex items-center justify-center h-screen">
                <Spinner />
            </div>
        </>

    )
}

export default WebAppDownload